import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.344 11.094c.355 0 .656.3.656.656 0 .383-.3.656-.656.656h-5.688v5.688c0 .383-.3.656-.656.656a.63.63 0 0 1-.656-.656v-5.688H5.656A.63.63 0 0 1 5 11.75c0-.355.273-.656.656-.656h5.688V5.406c0-.355.273-.656.656-.656.355 0 .656.3.656.656v5.688z"
    }, null, -1)
  ]))]))
}
export default { render: render }